import request from "./request";

export const _http = {
  //上下账
  dispatchBillUpdown(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/detail/company-diff-fund-fictitious-updown",
      data: params,
    });
  },
  //获取商家账户信息
  dispatchGetCompanyAccount(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/getCompanyAccount",
      params: params,
    });
  },
  //差异基金调账上账红包账户
  dispatchTransDiffFundToRedActivity(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/updown/transDiffFundToRedActivity",
      data: params,
    });
  },
  //红包账单列表
  dispatchGetRedBageList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/detail/getList",
      data: params,
    });
  },
  //导出红包账单列表
  dispatchExport(params) {
    return request({
      method: "POST",
      url: "/platform/pc/account/detail/exportExcel",
      data: params,
      responseType: "blob",
    });
  },
  //红包发放记录
  dispatchSendRedBage(params) {
    return request({
      method: "POST",
      url: "/platform/pc/red/envelope/findRedEnvelopeActivitySendRecordList",
      data: params,
    });
  },
  //导出红包发放记录
  dispatchExportSendRedBadge(params) {
    return request({
      method: "POST",
      url: "/platform/pc/red/envelope/excelRedActivitySendRecord",
      data: params,
      responseType: "blob",
    });
  },
  //活动列表
  dispatchGetActiveList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/red/envelope/getActivitySelectList",
      params: params,
    });
  },
  //获取商户下拉列表
  dispatchGetKACompanyList() {
    return request({
      method: "GET",
      url: "/platform/pc/company/getKACompanyList",
    });
  },
  //导入批量任务
  dispatchImport(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/import",
      data: params,
    });
  },
  //上下账导入记录
  dispatchUpDownList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/list",
      data: params,
    });
  },
  //下载导入数据
  dispatchExcelImport(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/excel-import",
      data: params,
      responseType: "blob",
    });
  },
  //上下账下沉记录
  dispatchUIEventUpDownRollList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/batch/account/updown/up-down-roll-down-list",
      params: params,
    });
  },
  //确定上下账
  dispatchConfirm(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/confirm",
      data: params,
    });
  },
  //重新上下账
  dispatchReConfirm(params) {
    return request({
      method: "GET",
      url: "/platform/pc/batch/account/updown/re-confirm",
      params: params,
    });
  },
  //上下账记录
  dispatchAccountList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/up-down-list",
      data: params,
    });
  },
  //作废上账任务
  cancel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/cancel",
      data: params,
    });
  },
  //查询上账任务作废详情
  getCancelDetail(params) {
    return request({
      method: "POST",
      url: "/platform/pc/batch/account/updown/getCancelDetail",
      params: params,
    });
  },
  //故障项匹配数据
  queryFailureOrderMatchList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/order/failure/queryFailureOrderMatchList",
      data: params,
    });
  },
  //故障项树形
  findTreeFailure(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/findTreeFailure",
      params: params,
    });
  },
  findTreeFailure2(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/findTreeFailure2",
      params: params,
    });
  },
  //关键词列表
  getFailureKeywordList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/getFailureKeywordList",
      params: params,
    });
  },
  //添加关键词
  saveFailureKeyword(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/failure/saveFailureKeyword",
      data: params,
    });
  },
  //删除关键词列表
  removeFailureKeyword(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/removeFailureKeyword",
      params: params,
    });
  },
  //故障项列表
  queryFailureList(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/failure/queryFailureList",
      data: params,
    });
  },
  //保存添加故障项
  saveFailure(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/failure/saveFailure",
      data: params,
    });
  },
  //应用到回收端
  updateEnableMerchant(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/updateEnableMerchant",
      params: params,
    });
  },
  //是否同步到AI问答提示词
  updateSyncAi(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/updateSyncAi",
      params: params,
    });
  },
  //查询AI提示词
  getAIQandAInfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/getAIQandAInfo",
      params: params,
    });
  },
  //保存AI提示词
  saveAIQandAInfo(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/failure/saveAIQandAInfo",
      data: params,
    });
  },
  //导出故障项匹配数据
  excelFailureOrderMatch(params) {
    return request({
      method: "POST",
      url: "/platform/pc/platform/failure/excelFailureOrderMatch",
      data: params,
      responseType: "blob",
    });
  },
  //故障项匹配情况
  queryOrderMatchRecord(params) {
    return request({
      method: "GET",
      url: "/platform/pc/platform/failure/queryOrderMatchRecord",
      params: params,
    });
  },
  //是否自动报价日志
  autoQuoteLog(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/failure/autoQuoteLog",
      params: params,
    });
  },
  //sku对比详情
  skuinfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/failure/sku-info",
      params: params,
    });
  },
    //亮屏照
  lightscreeninfo(params) {
    return request({
      method: "GET",
      url: "/platform/pc/order/failure/light-screen-info",
      params: params,
    });
  },
};
